import React from 'react';
import { BottomNavigation, NavBarPrimary } from '../../moleculs';
interface LayoutProps {
    children?: React.ReactNode,
    showNavBar?: boolean,
    showNavigation?: boolean,
    title?: string
}

const Layout = (props: LayoutProps) => {
    const { children, showNavBar = true, showNavigation = false, title } = props;
    return (
        <>
            <div className='container'>
                {showNavBar ? <NavBarPrimary title={title} /> : null}
                <div className="page background-img">
                    {children}
                </div>
                {showNavigation ? <BottomNavigation /> : null}
            </div>
        </>
    );
};

export default Layout;